<div class="bg-gray d-flex justify-content-between mb-5 py-2 px-4">
    <div class="d-flex align-items-center">
        <!--    <a href="javascript:void(0)" [routerLink]="['/']">
                <svg-icon src="assets/svg/arrow.svg"></svg-icon>
            </a>-->
        <span class="m-0 ml-4 size-xxm text-gray-secondary font-weight-normal"><strong>Home</strong></span>
    </div>
</div>
